import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=2397a9f5&"
import script from "./SpinnerButton.vue?vue&type=script&lang=ts&"
export * from "./SpinnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2397a9f5')) {
      api.createRecord('2397a9f5', component.options)
    } else {
      api.reload('2397a9f5', component.options)
    }
    module.hot.accept("./SpinnerButton.vue?vue&type=template&id=2397a9f5&", function () {
      api.rerender('2397a9f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/SpinnerButton.vue"
export default component.exports